import { TestDefinition, QuestionType } from '../../types';

// Escala 1-5 para WHODAS 2.0
const whodasScale = [
  { label: 'Ninguna', value: 1 },
  { label: 'Leve', value: 2 },
  { label: 'Moderada', value: 3 },
  { label: 'Severa', value: 4 },
  { label: 'Extrema/No puede hacerlo', value: 5 }
];

// Escala 0-10 para Sheehan
const sheehanScale = [
  { label: '0 - Nada', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5 - Moderado', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10 - Extremo', value: 10 }
];

export const TESTS_DISCAPACIDAD: TestDefinition[] = [
  {
    id: 'whodas-2.0',
    code: 'WHODAS 2.0',
    name: 'WHO Disability Assessment Schedule 2.0 (12-item)',
    category: 'Discapacidad',
    description: 'Escala de evaluación de discapacidad de la OMS versión breve. 12 ítems que evalúan dificultades en actividades de la vida diaria en los últimos 30 días. Incluye 6 dominios: cognición, movilidad, autocuidado, relaciones, actividades cotidianas y participación.',
    questions: [
      // COGNICIÓN (2 ítems)
      {
        id: 'w1',
        text: 'D1.1 Concentrarse en hacer algo durante diez minutos',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Cognición'
      },
      {
        id: 'w2',
        text: 'D1.2 Recordar cosas importantes que tiene que hacer',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Cognición'
      },

      // MOVILIDAD (2 ítems)
      {
        id: 'w3',
        text: 'D2.1 Estar de pie durante largos períodos (como 30 minutos)',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Movilidad'
      },
      {
        id: 'w4',
        text: 'D2.2 Desplazarse dentro de su casa',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Movilidad'
      },

      // AUTOCUIDADO (2 ítems)
      {
        id: 'w5',
        text: 'D3.1 Lavarse todo el cuerpo',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Autocuidado'
      },
      {
        id: 'w6',
        text: 'D3.2 Vestirse',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Autocuidado'
      },

      // RELACIONES (2 ítems)
      {
        id: 'w7',
        text: 'D4.1 Relacionarse con personas que no conoce',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Relaciones'
      },
      {
        id: 'w8',
        text: 'D4.2 Mantener una amistad',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Relaciones'
      },

      // ACTIVIDADES DE LA VIDA DIARIA (2 ítems)
      {
        id: 'w9',
        text: 'D5.1 Cumplir con las responsabilidades de la casa',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Actividades Cotidianas'
      },
      {
        id: 'w10',
        text: 'D5.2 Hacer bien las tareas domésticas más importantes',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Actividades Cotidianas'
      },

      // PARTICIPACIÓN (2 ítems)
      {
        id: 'w11',
        text: 'D6.1 Realizar sus actividades diarias',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Participación'
      },
      {
        id: 'w12',
        text: 'D6.2 Afectado emocionalmente por sus problemas de salud',
        type: QuestionType.LIKERT,
        options: whodasScale,
        subscale: 'Participación'
      }
    ],
    subscales: [
      {
        name: 'Cognición',
        questionIds: ['w1', 'w2'],
        description: 'Comprensión y comunicación'
      },
      {
        name: 'Movilidad',
        questionIds: ['w3', 'w4'],
        description: 'Desplazamiento y movilidad'
      },
      {
        name: 'Autocuidado',
        questionIds: ['w5', 'w6'],
        description: 'Higiene, vestirse, comer'
      },
      {
        name: 'Relaciones',
        questionIds: ['w7', 'w8'],
        description: 'Interacción con otras personas'
      },
      {
        name: 'Actividades Cotidianas',
        questionIds: ['w9', 'w10'],
        description: 'Responsabilidades domésticas y trabajo'
      },
      {
        name: 'Participación',
        questionIds: ['w11', 'w12'],
        description: 'Actividades comunitarias y sociales'
      }
    ],
    interpretations: [
      { min: 12, max: 18, label: 'Sin Discapacidad', color: 'bg-green-100 text-green-800' },
      { min: 19, max: 28, label: 'Discapacidad Leve', color: 'bg-yellow-100 text-yellow-800' },
      { min: 29, max: 38, label: 'Discapacidad Moderada', color: 'bg-orange-100 text-orange-800' },
      { min: 39, max: 48, label: 'Discapacidad Severa', color: 'bg-red-100 text-red-800' },
      { min: 49, max: 60, label: 'Discapacidad Extrema', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'sheehan',
    code: 'SDS',
    name: 'Sheehan Disability Scale',
    category: 'Discapacidad',
    description: 'Escala breve de 3 ítems para evaluar deterioro funcional en trabajo, vida social y vida familiar. Desarrollada por Sheehan (1983). Escala visual analógica 0-10 en cada dominio.',
    questions: [
      {
        id: 's1',
        text: '1. Trabajo/Estudios: Los síntomas han alterado su trabajo/estudios',
        type: QuestionType.LIKERT,
        options: sheehanScale
      },
      {
        id: 's2',
        text: '2. Vida social: Los síntomas han alterado su vida social',
        type: QuestionType.LIKERT,
        options: sheehanScale
      },
      {
        id: 's3',
        text: '3. Vida familiar: Los síntomas han alterado su vida familiar/responsabilidades del hogar',
        type: QuestionType.LIKERT,
        options: sheehanScale
      }
    ],
    interpretations: [
      { min: 0, max: 5, label: 'Sin Deterioro Funcional', color: 'bg-green-100 text-green-800' },
      { min: 6, max: 12, label: 'Deterioro Leve', color: 'bg-yellow-100 text-yellow-800' },
      { min: 13, max: 20, label: 'Deterioro Moderado', color: 'bg-orange-100 text-orange-800' },
      { min: 21, max: 30, label: 'Deterioro Severo', color: 'bg-red-200 text-red-900' }
    ]
  }
];
